import React  from 'react';
import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import { Provider } from 'react-redux';
import { Router, Route, browserHistory, IndexRoute, withRouter } from 'react-router';
import { syncHistoryWithStore, routerReducer } from 'react-router-redux';
import thunk from 'redux-thunk';

import Home from './landing/landing';
import SignUp from './auth/signup';
import Login from './auth/login';
import ForgotPassword from './auth/forgot_password';
import EnterPhoneNo from './auth/enter_phonenumber';

import Shipment from './shipment/shipment';
import ShipmentOffers from './shipment/offers';
import TrackShipment from './shipment/track_shipment';
import Account from './profile/account';
import NotificationsSettings from './profile/notification_settings/notification_settings';
import Profile from './profile/profile';
import AccountPayment from './profile/account_payment/account_payment';
import IDVerification from './profile/id_verification/id_verification'
import MyTrips from './profile/trips/trips'

import ContactSupport from './profile/contact_support';
import HowItWorks from './profile/how_it_works';
import Promocode from './profile/promocode';
import InviteFriends from './profile/inivite_friends';
import Legal from './profile/legal';
import SendFeedback from './profile/send_feedback';

import Main from './App';

import Dashboard from './dashboard/dashboard';

import ShippingDashboard from './dashboard/shipping_dashboard';
import CarryingDashBoard from './dashboard/carrying_dashboard';
import ReceivingDashBoard from './dashboard/receiving_dashboard';

import Notifications from './components/notification/notification';

import AddTrips from './add_trips/add_trips'

import PostAShipment from './post_a_shipment/post_a_shipment';
import PostAShipmentIntro from './post_a_shipment/post_a_shipment_intro/post_a_shipment_intro'
import UploadPhoto from './post_a_shipment/upload_shipment_photo/upload_shipment_photo'
import PackageDetails from './post_a_shipment/package_details/package_details';
import PostAShipmentPickupDetails from './post_a_shipment/pickup_details/pickup_details'
import PostAShipmentDeliveryDetails from './post_a_shipment/delivery_details/delivery_details'
import PostAShipmentConfirmDetails from './post_a_shipment/confirm_details/confirm_details';
import PostAShipmentPayment from './post_a_shipment/payment/post_a_shipment_payment';

import RequestAnItem from './request_an_item/request_an_item';
import RequestAnItemIntro from './request_an_item/request_an_item_intro/request_an_item_intro';
import RequestDetails from './request_an_item/request_details/request_details';
import DeliveryDetails from './request_an_item/delivery_details/delivery_details';
import ConfirmDetails from './request_an_item/confirm_details/confirm_details';
import RequestAnItemPayment from './request_an_item/payment/payment';

import Messages from './messages/messages';
import MessageShippingDashboard from './messages/message_shipping_dashboard.jsx';
import MessageCarryingDashboard from './messages/message_carrying_dashboard.jsx';
import MessageReceivingDashboard from './messages/message_receiving_dashboard.jsx';

import Privacy from './static_pages/privacy';
import TermsAndConditions from './static_pages/terms_and_conditions';
import PublicHowItWorks from './static_pages/how_it_works';
import PublicLegal from './static_pages/legal';
import CookiePolicy from './static_pages/cookies';
import FAQ from './static_pages/faq';

import About from './static_pages/about';
import Contact from './static_pages/contact';
import LearnMore from './static_pages/learn_more';

// import MessageDetail from './messages/chat';
import OneToOneChat from './messages/one_to_one_message';


//Root reducers
import reducers from './reducers';

import Payment from './payment/payment';

import BrowsePackages from './browse_packages/browse_packages';
import BrowsePackagesList from './browse_packages/browse_package_list';
import BrowsePackagesMap from './browse_packages/browse_package_map';
import SendMessage from './browse_packages/browse_send_message';
import DeliveryData from './browse_packages/browse_delivery_method';
import BrowsePaypaldetails from './browse_packages/browse_paypal_details';
import BrowsePaymentdetails from './browse_packages/payment/make_offer_payment'

import UserProfile from './user_profile/user_profile';

// Add the reducer to your store on the `routing` key
const store = createStore(
  combineReducers({
    app: reducers,
    routing: routerReducer
  }),
  applyMiddleware(thunk)
);

// Create an enhanced history that syncs navigation events with the store
const history = syncHistoryWithStore(browserHistory, store)

//If the user is not logged in and try to go back to private page redirect to login
function isUserLoggedIn(nextState,replace){
  const state = store.getState();
  const appState = state.app;
  const userData = appState.auth && appState.auth.userData;

  if (!userData) {
    replace({ nextPathname: nextState.location.pathname }, '/login');
  }
}

export default class App extends React.Component {
  render() {
    return (
      <Provider store = {store}>
        <Router history = {history} component = {Main}>
          <Route path = "/" component = {Home} />
          <Route path = "/signup" component = {SignUp} />
          <Route path = "/login" component = {Login} />
          <Route path = "/forgot-password" component = {ForgotPassword} />
          <Route path = "/enter-phoneno" component = {EnterPhoneNo} />

          <Route path = "/privacy-policy" component = {Privacy} />
          <Route path = "/terms-and-conditions" component = {TermsAndConditions} />
          <Route path = "/how-awb-works" component = {PublicHowItWorks} />
          <Route path = "/legal" component = {PublicLegal} />
          <Route path = "/cookie-policy" component = {CookiePolicy} />
          <Route path = "/faq" component ={FAQ} />

          <Route path = "/about" component = {About} />
          <Route path = "/contact" component = {Contact} />
          <Route path = "/learn-more" component = {LearnMore} />

          <Route path = "/dashboard" component = {Dashboard} onEnter = {isUserLoggedIn}>
            <IndexRoute component={ShippingDashboard} onEnter = {isUserLoggedIn}/>
            <Route path = "i-am-shipping" component = {ShippingDashboard} onEnter = {isUserLoggedIn}></Route>
            <Route path = "i-am-carrying" component = {CarryingDashBoard} onEnter = {isUserLoggedIn}></Route>
            <Route path = "i-am-receiving" component = {ReceivingDashBoard} onEnter = {isUserLoggedIn}></Route>
          </Route>

          <Route path="/inbox" component = {Messages} onEnter = {isUserLoggedIn} >
            <IndexRoute component={MessageShippingDashboard} onEnter = {isUserLoggedIn} />
            <Route path="i-am-shipping" component = {MessageShippingDashboard} onEnter = {isUserLoggedIn} ></Route>
            <Route path="i-am-carrying" component = {MessageCarryingDashboard} onEnter = {isUserLoggedIn} ></Route>
            <Route path="i-am-receiving" component = {MessageReceivingDashboard} onEnter = {isUserLoggedIn} ></Route>
          </Route>

          <Route path="/inbox-chat/:shipmentId/:carrierId" component = {OneToOneChat} onEnter = {isUserLoggedIn} />

          <Route path = "/shipment/:shipmentId" component = {Shipment} onEnter = {isUserLoggedIn}/>
          <Route path = "/shipment-offers/:shipmentId" component = {ShipmentOffers} onEnter = {isUserLoggedIn}/>

          <Route path = "/track-shipment/:shipmentId" component = {TrackShipment} onEnter = {isUserLoggedIn}/>

          <Route path = "/account" component = {Account} onEnter = {isUserLoggedIn}/>
          <Route path = "/profile" component = {Profile} onEnter = {isUserLoggedIn}/>
          <Route path = "/contact-support" component = {ContactSupport} onEnter = {isUserLoggedIn}/>
          <Route path = "/how-it-works" component = {HowItWorks} onEnter = {isUserLoggedIn}/>
          <Route path = "/promocode" component = {Promocode} onEnter = {isUserLoggedIn}/>
          <Route path = "/invite-friends" component = {InviteFriends} onEnter = {isUserLoggedIn}/>
          <Route path = "/legal-content" component = {Legal} onEnter = {isUserLoggedIn}/>
          <Route path = "/send-feedback" component = {SendFeedback} onEnter = {isUserLoggedIn}/>
          <Route path = "/notifications" component = {NotificationsSettings} onEnter = {isUserLoggedIn}/>
          <Route path = "/account-payment" component = {AccountPayment} onEnter = {isUserLoggedIn}/>
          <Route path = "/id-verification" component = {IDVerification} onEnter = {isUserLoggedIn}/>
          <Route path = "/all-notifications" component = {Notifications} onEnter = {isUserLoggedIn} />
          <Route path = "/my-trips" component = {MyTrips} onEnter = {isUserLoggedIn} />

          <Route path = "/add-trips" component = {AddTrips} onEnter = {isUserLoggedIn}/>

          <Route path = "/post-a-shipment" component = {PostAShipment} onEnter = {isUserLoggedIn}>
            <IndexRoute component={PostAShipmentIntro} onEnter = {isUserLoggedIn}/>
            <Route path = "intro" component = {PostAShipmentIntro} onEnter = {isUserLoggedIn}></Route>
            <Route path = "upload-photo" component = {UploadPhoto} onEnter = {isUserLoggedIn}></Route>
            <Route path = "package-details" component = {PackageDetails} onEnter = {isUserLoggedIn}></Route>
            <Route path = "pickup-details" component = {PostAShipmentPickupDetails} onEnter = {isUserLoggedIn}></Route>
            <Route path = "delivery-details" component = {PostAShipmentDeliveryDetails} onEnter = {isUserLoggedIn}></Route>
            <Route path = "confirm-details" component = {PostAShipmentConfirmDetails} onEnter = {isUserLoggedIn}></Route>
              <Route path = "payment" component = {PostAShipmentPayment} onEnter = {isUserLoggedIn}></Route>
          </Route>

          <Route path = "/request-an-item" component = {RequestAnItem} onEnter = {isUserLoggedIn}>
              <IndexRoute component={RequestAnItemIntro} onEnter = {isUserLoggedIn}/>
              <Route path = "intro" component = {RequestAnItemIntro} onEnter = {isUserLoggedIn}></Route>
              <Route path = "request-details" component = {RequestDetails} onEnter = {isUserLoggedIn}></Route>
              <Route path = "delivery-details" component = {DeliveryDetails} onEnter = {isUserLoggedIn}></Route>
              <Route path = "confirm-details" component = {ConfirmDetails} onEnter = {isUserLoggedIn}></Route>
              <Route path = "payment" component = {RequestAnItemPayment} onEnter = {isUserLoggedIn}></Route>
         </Route>

          <Route path = "/location" component = {Location} onEnter = {isUserLoggedIn} />

          <Route path = "/browse-shipments" component = {BrowsePackages} onEnter = {isUserLoggedIn} >
            <IndexRoute component = {BrowsePackagesList} onEnter = {isUserLoggedIn} />
            <Route path = "list" component = {BrowsePackagesList} onEnter = {isUserLoggedIn}></Route>
            <Route path = "map" component = {BrowsePackagesMap} onEnter = {isUserLoggedIn}></Route>
            <Route path = "send-message/:shipmentId" component = {SendMessage} onEnter = {isUserLoggedIn}></Route>
            <Route path = "select-delivery-type/:shipmentId" component = {DeliveryData} onEnter = {isUserLoggedIn}></Route>
            <Route path = "paypal-details/:shipmentId" component = {BrowsePaypaldetails} onEnter = {isUserLoggedIn}></Route>
            <Route path = "payment/:shipmentId" component = {BrowsePaymentdetails} onEnter = {isUserLoggedIn}></Route>
          </Route>
          <Route path = "user-profile/:userId" component = {UserProfile} onEnter = {isUserLoggedIn}></Route>
        </Router>
      </Provider>
    );
  }
}



// WEBPACK FOOTER //
// app/routes.jsx